import { render, staticRenderFns } from "./SouMaisPrevisul.vue?vue&type=template&id=e0a664e2"
import script from "./SouMaisPrevisul.vue?vue&type=script&lang=js"
export * from "./SouMaisPrevisul.vue?vue&type=script&lang=js"
import style0 from "./SouMaisPrevisul.vue?vue&type=style&index=0&id=e0a664e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports